export default class RibbonBannerDynamicText {
    constructor() {
        this.ribbonContainer = document.getElementById('js-ribbon-content');
        this.rangeEl = document.getElementById('water-usage-slider');
        this.rangeLabel = document.getElementById('water-usage-label');
        if (! window.ribbonMessages || ! this.ribbonContainer) {
            return;
        }
        this.changeText();
        this.rangeChange();
    }
    changeText() {
        const bannerLines = window.ribbonMessages;
        const changeSpeed = this.ribbonContainer.getAttribute('data-ribbon-speed');
        this.createRibbonContentEls(bannerLines);
        this.spans = document.querySelectorAll('.header-ribbonBanner-content');
        if (! this.spans.length) {
            return;
        }
        this.spans[0].classList.add('header-ribbonBanner--change');
        let counter = 1;
        setInterval(() => {
            this.resetAll();
            this.spans[counter].classList.add('header-ribbonBanner--change');
            counter++;
            if (counter >= bannerLines.length) {
                counter = 0;
            }
        }, changeSpeed);
    }

    resetAll() {
        for (const span of this.spans) {
            span.classList.remove('header-ribbonBanner--change');
        }
    }

    updateNodeText(val) {
      for (let i=0;i<this.spans.length;i++) {
          this.spans[i].textContent = `${window.ribbonMessages[i]} (slider value: ${val})`;
      }
    }

    rangeChange() {
        if(! this.rangeEl) {
            console.log('no range el');
            return;
        }
        
        const self = this;

        this.rangeEl.addEventListener('change', function(ev) {
            window.waterRangeValue = this.value;
            self.rangeLabel.textContent = this.value;
            self.updateNodeText(this.value);
        });
    }

    createRibbonContentEls(bannerLines) {

        bannerLines.forEach((line) => {
            const span = document.createElement('span');
            span.textContent = line;
            span.className = 'header-ribbonBanner-content';
            this.ribbonContainer.appendChild(span);
        });
    }
}
